<script>
  import { LayerCake, ScaledSvg, Html } from 'layercake';
  import MapSvg from "./components/Map.svg.svelte";
  import Infobox from "./components/Infobox.svelte";
  import Buttons from './components/Buttons.svelte';
  import { bundeslaender, 
            bundeslaenderData, 
            bundeslaenderDataComparison,
            options,
            colorScales, 
            charts,
            aspectRatio,
            steps
          } from "./data";
  import { geoMercator } from "d3-geo";
  import { scaleLinear } from "d3-scale";

  const projection = geoMercator;

  console.log(bundeslaenderData);

  const trends = {}

  export let subject = 'lesen';
  export let state = 'by';

  function percent(v, comp) {
    return ((v/comp) * 100 - 100).toFixed(1).toString().replace('.', ',');
  }

  bundeslaenderData.forEach((v) => {
    const comp = bundeslaenderDataComparison.find(x => x.state === v.state);
    trends[v.state] = {
      rechtschreibung: percent(v.rechtschreibung,comp.rechtschreibung),
      lesen: percent(v.lesen, comp.lesen),
      mathematik: percent(v.mathematik, comp.mathematik),
      zuhoeren: percent(v.zuhoeren, comp.zuhoeren)
    }
  });

  let infobox;




  bundeslaender.features.forEach((f) => {
    const d = bundeslaenderData.filter(x => x.state === f.properties.id)[0];
    f.properties = {...f.properties, ...d};
  });
  const data = bundeslaender.features.map(d => d.properties);

  function mousemove(e) {
    state = e.detail.props.id;
    infobox.update(subject, e.detail.props.id)
  }

  function update(subj) {
    subject = subj.detail.subj;
  }


</script>

<div class="buttons-container">
  <Buttons 
    bind:value={subject} 
    {options} 
    let:option 
    {infobox} 
    {data} 
    {subject} 
    {state}
    on:update={update}
    >
    <div class="main">
      {@html option.label}
    </div>
  </Buttons>
</div>


<div class="bundeslaender">
  <!-- export const steps = [420, 440, 460, 480, 500, 998]; -->

  <div class="flexwrapper">
  <div class="map-container" style="--ratio: {aspectRatio};">
    <div class="map-legend">
      <div class="title"></div>
      <div class="ticks">
        {#each colorScales[subject] as v, i}
          <div class="tick" style="background-color: {v}">
            {#if steps[i] == '998'}
              <span>Keine Daten</span>
            {:else if steps[i] == '420'}
              <span>schlechter</span>
            {:else if steps[i] == '500'}
              <span>besser</span>
            {/if}
          </div>
        {/each}
      </div>
    </div>
    <div class="map-innercontainer">
      <LayerCake
        ssr={true}
        position='absolute'
        data={bundeslaender}
        z={subject}
        zDomain={steps}
        zRange={colorScales[subject]}
        zScale={scaleLinear()}
        flatData={data}
      >
        <ScaledSvg
          fixedAspectRatio={aspectRatio}
        >
          <MapSvg
            fixedAspectRatio={aspectRatio}
            {projection}
            stroke="#fff"
            strokeHover="#000"
            strokeWidth={0.5}
            strokeWidthHover={2.5}
            on:mousemove={mousemove}
          />
        </ScaledSvg>
      </LayerCake>
  </div>

  </div>

  <Infobox data={data} {state} {subject} {options} {trends} {charts} bind:this={infobox}></Infobox>
  </div>
</div>





<style lang="scss">
  @import "./main.scss";

  .bundeslaender {
    font-family: $ff-sans;
    font-size: 17px;
    line-height: 23px;
    font-weight: normal;
    color: #000;
    // border: 1px solid #848484;


    @media (max-width: 480px) {
      font-size: 16px;
      line-height: 22px;
    }
  }

  .flexwrapper {
    display: flex;
    margin-top: 20px;

    @media (max-width: $breakpoint-tablet-s) {
      flex-direction: column;
      margin-top: 0;
    }
  }

  .map-container {
    position: relative;
    width: 100%;
    flex-grow: 1;
    margin-top: 40px;
    margin-right: 44px;
    height: calc(98% / var(--ratio));
    max-height: 440px;
    max-width: 310px;

    @media (max-width: $breakpoint-tablet-s) {
      position: static;
      display: flex;
      max-width: 320px;
      align-self: center;
      height: calc(68% / var(--ratio));
      margin-top: 0;
      margin-right: 0;
    }
  }

  .map-innercontainer {
    position: relative;
    width: 100%;
    height: 0;
    flex-shrink: 0;
    margin-top: 32px;
    opacity: 0;
    animation: fadein ease .5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    
    padding-bottom: calc(98% / var(--ratio));
    
    @media (max-width: $breakpoint-tablet-s) {
      max-width: 220px;
      margin-top: 16px;
      padding-bottom: calc(68% / var(--ratio));
    }
  }

  .map-legend{
    position: absolute;
    top: -30px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: last baseline;

    @media (max-width: $breakpoint-tablet-s) {
      position: static;
      justify-content: left;
      display: block;
      margin-top: 32px;
    }

    .title {
      padding: 0 8px;
      font-weight: 600;
      font-siZe: 12px;
      line-height: 24px;
      margin-right: 7px;
      align-self: baseline;
      margin-bottom: 9px;
    }

    .ticks {
      display: inline-flex;
      height: 11px;

      @media (max-width: $breakpoint-tablet-s) {
       flex-direction: column-reverse;
       height: auto;
      }

      .tick {
        position: relative;
        width: 33px;

      @media (max-width: $breakpoint-tablet-s) {
        height: 20px;
        width: 9px;
        order: 2;
      }

       span {
        display: block;
        text-align: center;
        margin-top: -22px;
        margin-left: 0;
        font-size: 12px;
        line-height: 24px;

        @media (max-width: $breakpoint-tablet-s) {
         margin-left: 14px;
         margin-top: -10px;
        }
       }

       &:first-child span {
        @media (max-width: $breakpoint-tablet-s) {
            margin-top: 2px;
          }
       }

       &:last-child {
        order: 1;
        margin-left: 10px;

        @media (max-width: $breakpoint-tablet-s) {
          margin-left: 0;
          margin-top: 4px;
        }
        

        span {
          white-space: nowrap;

          @media (max-width: $breakpoint-tablet-s) {
            margin-top: -4px;
          }

          @media (min-width: $breakpoint-tablet-s) {
            margin-left: 0;
          }
        }
       }
      }
    }
  }

  @keyframes fadein {
      0% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }
</style>
